import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import { Reveal, SectionLabel } from "./Reveal";

const faqs = [
  {
    q: "What does MBM stand for?",
    a: "MBM stands for Mind Before Markets. The name is the whole philosophy in three words. Before our founder ever traded a chart, he spent years on construction sites as a director and licensed builder, learning that nothing of lasting value is built without discipline, repetition and respect for the process. When he moved into trading, he watched talented people blow up accounts, not because they lacked strategy, but because they let fear, greed and impatience run the show. He realised the market was never the real opponent, the mind was. So he built MBM around a simple truth: master the mind first, and the markets follow. Mind Before Markets, always.",
  },
  {
    q: "Is MBM a 'get rich quick' service?",
    a: "No. MBM is an education and mentorship company. We do not sell tips or shortcuts, guarantee profits, or promise income. Everything is analysis and decision support only. We teach the psychology, discipline and skills required to trade consistently.",
  },
  {
    q: "Do I need prior trading experience?",
    a: "No. Guest access and the Trading Trainer are built for complete beginners. The Advanced and Professional coaching programs are best suited to traders who already have some experience and are serious about improving.",
  },
  {
    q: "How does membership work?",
    a: "Trading Trainer is an ongoing app subscription (weekly, monthly or yearly). The Academy programs, Beginner, Advanced and Professional, are structured coaching programs with fixed durations rather than ongoing subscriptions. Elite is application only. You can also start free as a Guest to preview the platform.",
  },
  {
    q: "What will I actually learn?",
    a: "Mindset, risk management, professional trading skills, psychology and consistency, taught step by step, in plain language, without the confusing jargon.",
  },
  {
    q: "Will you help me get funded?",
    a: "Our Professional and Elite pathways include funded trader preparation focused on risk and discipline. Passing any evaluation depends on your own execution, outcomes are never guaranteed.",
  },
  {
    q: "Is this financial advice?",
    a: "No. All content is educational only and does not constitute financial or investment advice. Trading involves substantial risk of loss.",
  },
];

export default function FAQ() {
  return (
    <section
      id="faq"
      className="relative py-24 sm:py-32 lg:py-40 border-t border-white/5"
      data-testid="faq-section"
    >
      <div className="max-w-4xl mx-auto px-6 lg:px-8">
        <Reveal>
          <SectionLabel>Frequently Asked</SectionLabel>
        </Reveal>
        <Reveal delay={0.1}>
          <h2 className="mt-6 font-heading text-3xl sm:text-4xl lg:text-5xl font-light tracking-tight">
            Clarity before commitment.
          </h2>
        </Reveal>

        <Reveal delay={0.2}>
          <Accordion type="single" collapsible className="mt-12 w-full">
            {faqs.map((f, i) => (
              <AccordionItem
                key={i}
                value={`item-${i}`}
                className="border-b border-white/10"
                data-testid={`faq-item-${i}`}
              >
                <AccordionTrigger className="text-left font-heading text-lg sm:text-xl font-light text-zinc-100 hover:text-white py-6 hover:no-underline">
                  {f.q}
                </AccordionTrigger>
                <AccordionContent className="text-sm lg:text-base text-zinc-400 font-light leading-relaxed pb-6">
                  {f.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </Reveal>
      </div>
    </section>
  );
}
